import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { merchantApi } from "@api";
import { ArrowLeftColor } from "@components";
import { PATH_HOME, PATH_MEMBER_TYPE } from "@configs";
import { IGroupType } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta, useNotify } from "@utils";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const PageMemberGroup = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const { success, error } = useNotify();

    useEffect(() => {
        getTypeList();
    }, []);
    const [groupList, setGroupList] = useState<IGroupType[]>([]);

    const getTypeList = async () => {
        let res = await merchantApi.getMemberType();
        if (res.data?.result?.MemberTypeConfig?.isMemberApply) {
            setGroupList(res.data?.result?.MemberTypeConfig?.memberTypeGroupName);
        }
    };

    const clickType = (typeUrl: string) => {
        history.push(PATH_MEMBER_TYPE + typeUrl);
    };

    const clickBack = () => {
        history.push(PATH_HOME);
    };

    console.log("groupList", groupList);

    return (
        <StyledTypePage themeColor={themes?.themeColor!}>
            <RenderMeta title={t("meta.membertype_page")} />
            <div className="backIcon" onClick={() => history.push("/")}>
                <ArrowLeftColor color={themes?.themeColor} />
                {/* <span>{t("page.back")}</span> */}
            </div>
            <div className="layout-back" onClick={() => history.goBack()}>
                <h1>{t("page.selectmembergroup")}</h1>
            </div>
            <div className="list-section">
                {groupList?.map((tItem, tIndex) => {
                    return (
                        <div
                            className="list-item"
                            key={tIndex}
                            onClick={() => clickType(tItem?.typeGroupNameUrlPath)}
                        >
                            <div className="image-group">
                                <img src={tItem?.typeGroupNameList[0]?.typeNameCoverImage} alt="" />
                            </div>
                            {tItem?.typeGroupName}
                            {/* <div className="icon-group">
                                <img src={tItem?.typeGroupNameList[0]?.typeNameIcon} alt="" />
                            </div> */}
                        </div>
                    );
                })}
            </div>
        </StyledTypePage>
    );
};

const StyledTypePage = styled.div<{ themeColor: string }>`
    padding: 20px;
    height: 100vh;
    position: relative;
    background-color: #fff;
    .backIcon {
        position: absolute;
        top: 20px;
        left: 20px;
        cursor: pointer;
        z-index: 1;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .layout-back {
        position: absolute;
        left: 20px;
        top: 20px;
        display: flex;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: right;
        width: calc(100% - 32px);
    }
    h1 {
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: ${(p) => p.themeColor};
        margin-bottom: 0;
    }
    .list-section {
        margin: 70px 0;
        .list-item {
            background-color: #f4f4f4;
            margin: 10px 0;
            padding: 20px 90px;
            cursor: pointer;
            border-radius: 8px;
            font-size: 14px;
            position: relative;
            .image-group {
                width: 45px;
                height: 45px;
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .icon-group {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 5px;
                top: 5px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
`;
